import { Component } from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from 'ionic-angular';
import {FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { SuperTabsController } from "../../components/ionic2-super-tabs/src";
import { ReportService } from "../../services/report.service";
import {InfoModalPage} from "../info-modal/info-modal";

@Component({
  selector: 'page-report-customer-external',
  templateUrl: 'report-customer-external.html',
})
export class ReportCustomerExternalPage {

  data: any;
  reportForm: FormGroup;

  expanded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public superTabsCtrl: SuperTabsController,
    public reportService: ReportService
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.customers) this.data.customers = {};

    this.expanded = (this.data.customers.external && this.data.customers.external._same_as_client === 0);
    let has_data = (this.data.customers.external != null);
    this.reportForm = this.formBuilder.group({
      _requires_action: new FormControl((has_data ? this.data.customers.external._requires_action : '2')),
      company: [(has_data ? this.data.customers.external.company : '')],
      firstname: [(has_data ? this.data.customers.external.firstname : '')],
      lastname: [(has_data ? this.data.customers.external.lastname : '')],
      email: [(has_data ? this.data.customers.external.email : ''), Validators.compose([Validators.email, Validators.required])],
      phone: [(has_data ? this.data.customers.external.phone : '')],
      mobile: [(has_data ? this.data.customers.external.mobile : '')],
      street: [(has_data ? this.data.customers.external.street : ''), Validators.required],
      number: [(has_data ? this.data.customers.external.number : ''), Validators.required],
      letter: [(has_data ? this.data.customers.external.letter : '')],
      zipcode: [(has_data ? this.data.customers.external.zipcode : ''), Validators.required],
      city: [(has_data ? this.data.customers.external.city : ''), Validators.required],
      country: [(has_data && this.data.customers.external.country ? this.data.customers.external.country : 'NL'), Validators.required],
      kvk: [(has_data ? this.data.customers.external.kvk : '')],
      vat_nr: [(has_data ? this.data.customers.external.vat_nr : '')]
    });
  }

  ionViewDidEnter() {
    console.log('ReportCustomerExternalPage: ionViewDidEnter');
    this.initForm();
  }

  ionViewDidLeave(){
    console.log('ReportCustomerExternalPage: ionViewDidLeave');
    this.save();
  }

  isValid(){
    if(!this.expanded || this.reportForm.valid){
      return true;
    }
    return false;
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.reportForm.valid || !this.expanded){
      this.superTabsCtrl.setColor('reportCustomerExternalPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportCustomerExternalPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportCustomerExternalPage', 'tab_error', 'mainTabs');
      this.data._valid.reportCustomerExternalPage = -1;
    }
    if(!this.data.customers.external) this.data.customers.external = {};
    Object.assign(this.data.customers.external, this.reportForm.value);
    //this.data._has_external_customer = (this.expanded ? 1 : 0);
    this.data.customers.external._same_as_client = (this.expanded ? 0 : 1);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportSelectUnitPage', 'mainTabs');
    });
  }

  public openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-customer-external/report-customer-external.ts